

<div [ngClass]="{'text-ltr':!languagesService.isRightToLeft,'text-rtl':languagesService.isRightToLeft}">
  <div class="wraper">
    <div class="area" style="text-align: center">
      <div class="row" >
          <div class="col-md-1 col-xs-1" ></div>
          <div class="col-md-10 col-xs-10">
              <br>
              <h5><strong>טופס הרשמה לתושבים חוזרים נקלט בהצלחה</strong></h5>
              
          </div>
          <div class="col-md-12 col-xs-12">
            <h6>משרד העלייה והקליטה מעניק לתושבים החוזרים סיוע ושירותים מגוונים העשויים להקל על קליטתכם בארץ.</h6>
            <br>
          </div>
      </div>
      <!-- <div class="row" *ngIf="baseService.loginWay">
        <div class="col-md-12 col-xs-12">
            <label>{{name}}</label>
        </div>
        <div class="col-md-12 col-xs-12">
          <div class="controls-group">
            <label [innerHTML]="'welcome.description'| translate"></label>
          </div>
        </div>
        <div class="col-md-12 col-xs-12">
            <div class="controls-group">
              <label [innerHTML]="'welcome.open-services'| translate"></label><br>
              <a routerLink="/assistance" target="_blank" (click)="goToAssistance($event)">{{getRegisterForAssistenceLabel() | translate}} </a><br>
            </div>
        </div>
      </div>
      <div class="row" *ngIf="!baseService.loginWay">
          <div class="col-md-6 col-xs-12">
            <label>{{name}}</label>
            <div class="controls-group">
                <label [innerHTML]="'welcome.open-services'| translate"></label><br>
                <a routerLink="/assistance" target="_blank" (click)="goToAssistance($event)">{{getRegisterForAssistenceLabel() | translate}}</a><br>
              </div>
          </div>
          <div class="col-md-6 col-xs-12" *ngIf="partner_name != ''">
            <label>{{partner_name}}</label>
            <div class="controls-group">
                <label [innerHTML]="'welcome.open-services'| translate"></label><br>
                <a routerLink="/assistance" target="_blank" (click)="goToAssistance($event,false)">{{getRegisterForAssistenceLabel(false)| translate}}</a><br>
              </div>
          </div>
      </div> -->
    </div>
  </div>
</div>
